// THESE ARE FIXED VALUES THAT ARE SET WHEN MERCHANT DOES NOT WANT TO SEND RECURRING ORDERS
export const SUBSCRIPTION_SALES_CHANNELS = [
  {
    value: '294517',
    label: 'ReCharge'
  },
  {
    value: 'subscription_contract',
    label: 'Unified Checkout'
  }
];

export const SUBSCRIPTION_ORDER_TAGS = [
  {
    value: 'Subscription Recurring Order',
    label: 'Subscription Recurring Order'
  }
];

// These are a pre-filled list of options for customers to select from. They can add their own values as well.
export const SALES_CHANNEL_OPTIONS = [
  {
    value: 'shopify_draft_order',
    label: 'Draft Orders'
  },
  {
    value: '2329312',
    label: 'Facebook'
  },
  {
    value: '1424624',
    label: 'Gorgias'
  },
  {
    value: 'exchange',
    label: 'Happy Returns 2'
  },
  {
    value: '1662707',
    label: 'Loop Returns'
  },
  {
    value: 'Matrixify App',
    label: 'Matrixify App'
  },
  {
    value: 'pos',
    label: 'Point of Sale'
  },
  {
    value: '294517',
    label: 'ReCharge'
  },
  {
    value: 'subscription_contract',
    label: 'Unified Checkout'
  },
  {
    value: 'Returnly Exchanges',
    label: 'Returnly Returns'
  },
  {
    value: 'web',
    label: 'Web'
  },
  {
    value: 'amazon',
    label: 'Amazon by Codisto'
  },
  {
    value: 'amazon-us',
    label: 'Amazon by Codisto - US'
  },
  {
    value: '457101',
    label: 'Bold Subscription'
  },
  {
    value: '1605585',
    label: 'Borderfree'
  },
  {
    value: 'Edit Order',
    label: 'Cleverific Edit Order'
  },
  {
    value: '1848011',
    label: 'Convictional'
  },
  {
    value: '2984603',
    label: 'eShopWorld'
  },
  {
    value: '2438651',
    label: 'Etsy Marketplace Integration'
  },
  {
    value: 'faire',
    label: 'Faire'
  },
  {
    value: 'flow',
    label: 'Flow'
  },
  {
    value: '2893285',
    label: 'Global-E'
  },
  {
    value: '2376822',
    label: 'Grin (Influencer)'
  },
  {
    value: 'Honeycomb',
    label: 'Honeycomb'
  },
  {
    value: 'Iconic_Order_SC2162437122',
    label: 'Indigo8'
  },
  {
    value: '18191b06c07b47afabb71b0eca90f6bc',
    label: 'Leap Services'
  },
  {
    value: '3070771',
    label: 'Narvar'
  },
  {
    value: '63627558913',
    label: 'OpenBorder'
  },
  {
    value: '4200331',
    label: 'Refundid'
  },
  {
    value: '188741',
    label: 'Reamaze'
  },
  {
    value: '3890849',
    label: 'Shop'
  },
  {
    value: 'shopify-collective-automatic-payments',
    label: 'Shopify Collective'
  },
  {
    value: 'iphone',
    label: 'Shopify Mobile'
  },
  {
    value: '4092473',
    label: 'Sticky.io'
  },
  {
    value: '1520611',
    label: 'Tapcart'
  },
  {
    value: 'tiktok',
    label: 'TikTok'
  },
  {
    value: '38759497729',
    label: 'Upfluence'
  },
  {
    value: 'Walmart.com',
    label: 'Walmart Marketplace'
  },
  {
    value: '116649',
    label: 'Zapier'
  }
];

export const ORDER_TAG_OPTIONS = [...SUBSCRIPTION_ORDER_TAGS];

// THIS IS FROM ELEVAR - TODO DELETE LATER ONCE VERIFIED
// const S2e = {
//     name: 'Draft Orders',
//     code: 'shopify_draft_order',
//   },
//   _2e = {
//     name: 'Facebook',
//     code: '2329312',
//   },
//   j2e = {
//     name: 'Gorgias',
//     code: '1424624',
//   },
//   I2e = {
//     name: 'Happy Returns 2',
//     code: 'exchange',
//   },
//   E2e = {
//     name: 'Loop Returns',
//     code: '1662707',
//   },
//   T2e = {
//     name: 'Matrixify App',
//     code: 'Matrixify App',
//   },
//   M2e = {
//     name: 'Point of Sale',
//     code: 'pos',
//   },
//   Fr = {
//     name: 'ReCharge',
//     code: '294517',
//   },
//   yr = {
//     name: 'Unified Checkout',
//     code: 'subscription_contract',
//   },
//   L2e = {
//     name: 'Returnly Returns',
//     code: 'Returnly Exchanges',
//   },
//   TD = {
//     name: 'Web',
//     code: 'web',
//   },
//   kf = [
//     {
//       name: 'Amazon by Codisto',
//       code: 'amazon',
//     },
//     {
//       name: 'Amazon by Codisto - US',
//       code: 'amazon-us',
//     },
//     {
//       name: 'Bold Subscription',
//       code: '457101',
//     },
//     {
//       name: 'Borderfree',
//       code: '1605585',
//     },
//     {
//       name: 'Cleverific Edit Order',
//       code: 'Edit Order',
//     },
//     {
//       name: 'Convictional',
//       code: '1848011',
//     },
//     S2e,
//     {
//       name: 'eShopWorld',
//       code: '2984603',
//     },
//     {
//       name: 'Etsy Marketplace Integration',
//       code: '2438651',
//     },
//     _2e,
//     {
//       name: 'Faire',
//       code: 'faire',
//     },
//     {
//       name: 'Flow',
//       code: 'flow',
//     },
//     {
//       name: 'Global-E',
//       code: '2893285',
//     },
//     j2e,
//     {
//       name: 'Grin (Influencer)',
//       code: '2376822',
//     },
//     I2e,
//     {
//       name: 'Honeycomb',
//       code: 'Honeycomb',
//     },
//     {
//       name: 'Indigo8',
//       code: 'Iconic_Order_SC2162437122',
//     },
//     {
//       name: 'Leap Services',
//       code: '18191b06c07b47afabb71b0eca90f6bc',
//     },
//     E2e,
//     T2e,
//     {
//       name: 'Narvar',
//       code: '3070771',
//     },
//     {
//       name: 'OpenBorder',
//       code: '63627558913',
//     },
//     M2e,
//     {
//       name: 'Refundid',
//       code: '4200331',
//     },
//     {
//       name: 'Reamaze',
//       code: '188741',
//     },
//     L2e,
//     {
//       name: 'Shop',
//       code: '3890849',
//     },
//     {
//       name: 'Shopify Collective',
//       code: 'shopify-collective-automatic-payments',
//     },
//     {
//       name: 'Shopify Mobile',
//       code: 'iphone',
//     },
//     {
//       name: 'Sticky.io',
//       code: '4092473',
//     },
//     {
//       name: 'Tapcart',
//       code: '1520611',
//     },
//     {
//       name: 'TikTok',
//       code: 'tiktok',
//     },
//     {
//       name: 'Upfluence',
//       code: '38759497729',
//     },
//     {
//       name: 'Walmart Marketplace',
//       code: 'Walmart.com',
//     },
//     TD,
//     {
//       name: 'Zapier',
//       code: '116649',
//     },
//   ]
